import { render } from "./InspectionView.vue?vue&type=template&id=fc1e3f9e"
import script from "./InspectionView.vue?vue&type=script&lang=js"
export * from "./InspectionView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__